/* eslint-disable react/no-multi-comp, max-len*/
import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import {
    Tooltip,
    TooltipBody,
    TooltipFooter,
    TooltipHeader,
    TooltipSubtitle,
} from 'react-wot-bootstrap'

import { toRoman } from 'helpers'
import { SORTIES_WITH_LEVEL, USER_ROLES } from 'helpers/i18n'

export const StatisticsOverallTooltip = () => (
    <Tooltip id={StatisticsOverallTooltip.id}>
        <TooltipBody>
            <TooltipSubtitle>
                <FormattedMessage
                    id="clanmanagement.tooltips.statistics_overall_header"
                    defaultMessage="Статистика за всё время"
                />
            </TooltipSubtitle>
            <FormattedMessage
                id="clanmanagement.tooltips.statistics_overall_body"
                defaultMessage="Показать статистику за всё время."
            />
        </TooltipBody>
    </Tooltip>
)
StatisticsOverallTooltip.id = 'statistics-overall-tooltip'


export const Statistics28DaysTooltip = () => (
    <Tooltip id={Statistics28DaysTooltip.id}>
        <TooltipBody>
            <TooltipSubtitle>
                <FormattedMessage
                    id="clanmanagement.tooltips.statistics_28_days_header"
                    defaultMessage="Статистика за 28 дней"
                />
            </TooltipSubtitle>
            <FormattedMessage
                id="clanmanagement.tooltips.statistics_28_days_body"
                defaultMessage="Показать статистику за предыдущие 28 дней"
            />
        </TooltipBody>
    </Tooltip>
)
Statistics28DaysTooltip.id = 'statistics-28-days-tooltip'


export const Statistics7DaysTooltip = () => (
    <Tooltip id={Statistics7DaysTooltip.id}>
        <TooltipBody>
            <TooltipSubtitle>
                <FormattedMessage
                    id="clanmanagement.tooltips.statistics_7_days_header"
                    defaultMessage="Статистика за 7 дней"
                />
            </TooltipSubtitle>
            <FormattedMessage
                id="clanmanagement.tooltips.statistics_7_days_body"
                defaultMessage="Показать статистику за предыдущие 7 дней"
            />
        </TooltipBody>
    </Tooltip>
)
Statistics7DaysTooltip.id = 'statistics-7-days-tooltip'


export const Statistics1DayTooltip = () => (
    <Tooltip id={Statistics1DayTooltip.id}>
        <TooltipBody>
            <TooltipSubtitle>
                <FormattedMessage
                    id="clanmanagement.tooltips.statistics_1_day_header"
                    defaultMessage="Статистика за сутки"
                />
            </TooltipSubtitle>
            <FormattedMessage
                id="clanmanagement.tooltips.statistics_1_day_body"
                defaultMessage="Показать статистику за предыдущие сутки"
            />
        </TooltipBody>
    </Tooltip>
)
Statistics1DayTooltip.id = 'statistics-1-days-tooltip'


export const StatisticsDisabledPeriodTooltip = () => (
    <Tooltip id={StatisticsDisabledPeriodTooltip.id}>
        <TooltipBody>
            <FormattedMessage
                id="clanmanagement.tooltips.statistics_disabled_period_tooltip_1"
                defaultMessage="Невозможно выбрать период для данного режима боя."
            />
            <br />
            <FormattedMessage
                id="clanmanagement.tooltips.statistics_disabled_period_tooltip_2"
                defaultMessage="Статистика для выбранного режима доступна только за всё время."
            />
        </TooltipBody>
    </Tooltip>
)
StatisticsDisabledPeriodTooltip.id = 'statistics-disabled-period-tooltip'

export const StatisticsRandomDefaultBattleTypeTooltip = () => (
    <Tooltip id={StatisticsRandomDefaultBattleTypeTooltip.id}>
        <TooltipBody>
            <TooltipSubtitle>
                <FormattedMessage
                    id="clanmanagement.tooltips.statistics_random_default_battle_type_tooltip_header"
                    defaultMessage="Случайный бой 15×15"
                />
            </TooltipSubtitle>
            <FormattedMessage
                id="clanmanagement.tooltips.statistics_random_default_battle_type_tooltip"
                defaultMessage="Показать статистику игроков в Случайных боях 15 на 15, включая Стандартный бой, Штурм и Встречный бой."
            />
        </TooltipBody>
    </Tooltip>
)
StatisticsRandomDefaultBattleTypeTooltip.id = 'statistics-random-default-battle-type-tooltip'

export const StatisticsRandomEpicBattleTypeTooltip = () => (
    <Tooltip id={StatisticsRandomEpicBattleTypeTooltip.id}>
        <TooltipBody>
            <TooltipSubtitle>
                <FormattedMessage
                    id="clanmanagement.tooltips.statistics_random_epic_battle_type_tooltip_header"
                    defaultMessage="Случайный бой 30×30"
                />
            </TooltipSubtitle>
            <FormattedMessage
                id="clanmanagement.tooltips.statistics_random_epic_battle_type_tooltip"
                defaultMessage="Показать статистику игроков в Генеральных сражениях."
            />
        </TooltipBody>
    </Tooltip>
)
StatisticsRandomEpicBattleTypeTooltip.id = 'statistics-random-epic-battle-type-tooltip'


export const AboutIndicatorsClanModesTooltip = () => (
    <Tooltip id={AboutIndicatorsClanModesTooltip.id}>
        <TooltipHeader>
            <FormattedMessage
                id="clanmanagement.tooltips.about_indicators_clan_modes_header"
                defaultMessage="О показателях"
            />
        </TooltipHeader>
        <TooltipBody>
            <TooltipSubtitle>
                <FormattedMessage
                    id="clanmanagement.tooltips.about_indicators_clan_modes_subheader1"
                    defaultMessage="Бои"
                />
            </TooltipSubtitle>
            <p>
                <FormattedMessage
                    id="clanmanagement.tooltips.about_indicators_clan_modes_text1"
                    defaultMessage="Учитываются только бои в отрядах этого клана после вступления в него."
                />
            </p>
            <TooltipSubtitle>
                <FormattedMessage
                    id="clanmanagement.tooltips.about_indicators_clan_modes_subheader2"
                    defaultMessage="Промресурс"
                />
            </TooltipSubtitle>
            <p>
                <FormattedMessage
                    id="clanmanagement.tooltips.about_indicators_clan_modes_text2"
                    defaultMessage="Учитывается промресурс, который игрок заработал после вступления в клан как в его отрядах, так и легионером."
                />
            </p>
        </TooltipBody>
        <TooltipFooter>
            <FormattedMessage
                id="clanmanagement.tooltips.about_indicators_clan_modes_text3"
                defaultMessage="При повторном вступлении в клан учитывается статистика в том числе и до выхода из него."
            />
        </TooltipFooter>
    </Tooltip>
)
AboutIndicatorsClanModesTooltip.id = 'about-indicators-tooltip'


export const AboutIndicatorsStatisticsTooltip = () => (
    <Tooltip id={AboutIndicatorsStatisticsTooltip.id}>
        <TooltipBody>
            <TooltipSubtitle>
                <FormattedMessage
                    id="clanmanagement.tooltips.about_indicators_statistics_header"
                    defaultMessage="О показателях"
                />
            </TooltipSubtitle>
            <FormattedMessage
                id="clanmanagement.tooltips.about_indicators_statistics_body"
                defaultMessage="Учитываются все бои, проведённые игроком, вне зависимости от нахождения в клане."
            />
        </TooltipBody>
    </Tooltip>
)
AboutIndicatorsStatisticsTooltip.id = AboutIndicatorsClanModesTooltip.id


export const SelectedMembersTooltip = ({ count, total }) => (
    <Tooltip id={SelectedMembersTooltip.id}>
        <TooltipBody>
            <TooltipSubtitle>
                <FormattedMessage
                    id="clanmanagement.tooltips.selected_members_header"
                    defaultMessage="Выбранные игроки"
                />
            </TooltipSubtitle>
            <FormattedMessage
                id="clanmanagement.tooltips.selected_members_body"
                defaultMessage="Выбрано игроков: {count} из {total}"
                values={{ count, total }}
            />
        </TooltipBody>
    </Tooltip>
)
SelectedMembersTooltip.id = 'selected-members-tooltip'
SelectedMembersTooltip.propTypes = {
    count: PropTypes.number.isRequired,
    total: PropTypes.number.isRequired,
}


export const ClearSelectedMembersTooltip = () => (
    <Tooltip id={ClearSelectedMembersTooltip.id}>
        <TooltipBody>
            <TooltipSubtitle>
                <FormattedMessage
                    id="clanmanagement.tooltips.clear_selected_members_header"
                    defaultMessage="Отмена выбора"
                />
            </TooltipSubtitle>
            <FormattedMessage
                id="clanmanagement.tooltips.clear_selected_members_body"
                defaultMessage="Нажмите, чтобы отменить выбор игроков."
            />
        </TooltipBody>
    </Tooltip>
)
ClearSelectedMembersTooltip.id = 'clear-selected-members-tooltip'


export const RoleColumnTooltipContent = () => (
    <div>
        <TooltipBody>
            <TooltipSubtitle>
                <FormattedMessage
                    id="clanmanagement.tooltips.role_column_header"
                    defaultMessage="Должность"
                />
            </TooltipSubtitle>
            <FormattedMessage
                id="clanmanagement.tooltips.role_column_body"
                defaultMessage="Нажмите, чтобы отсортировать игроков по должности в клане."
            />
        </TooltipBody>
    </div>
)
RoleColumnTooltipContent.tip = 'role-column-tooltip-tip'


export const PlayerColumnTooltipContent = () => (
    <div>
        <TooltipBody>
            <TooltipSubtitle>
                <FormattedMessage
                    id="clanmanagement.tooltips.player_column_header"
                    defaultMessage="Игрок"
                />
            </TooltipSubtitle>
            <FormattedMessage
                id="clanmanagement.tooltips.player_column_body"
                defaultMessage="Нажмите, чтобы отсортировать игроков по имени."
            />
        </TooltipBody>
    </div>
)
PlayerColumnTooltipContent.tip = 'player-column-tooltip-tip'


export const Attack6ColumnTooltipContent = () => (
    <div>
        <TooltipBody>
            <TooltipSubtitle>
                {SORTIES_WITH_LEVEL(toRoman(6))}
            </TooltipSubtitle>
            <FormattedMessage
                id="clanmanagement.tooltips.attack_6_column_body"
                defaultMessage="Нажмите, чтобы отсортировать игроков по количеству боёв в Вылазках в VI дивизионе."
            />
        </TooltipBody>
    </div>
)
Attack6ColumnTooltipContent.tip = 'attack-6-column-tooltip-tip'


export const Attack8ColumnTooltipContent = () => (
    <div>
        <TooltipBody>
            <TooltipSubtitle>
                {SORTIES_WITH_LEVEL(toRoman(8))}
            </TooltipSubtitle>
            <FormattedMessage
                id="clanmanagement.tooltips.attack_8_column_body"
                defaultMessage="Нажмите, чтобы отсортировать игроков по количеству боёв в Вылазках в VIII дивизионе."
            />
        </TooltipBody>
    </div>
)
Attack8ColumnTooltipContent.tip = 'attack-8-column-tooltip-tip'


export const Attack10ColumnTooltipContent = () => (
    <div>
        <TooltipBody>
            <TooltipSubtitle>
                {SORTIES_WITH_LEVEL(toRoman(10))}
            </TooltipSubtitle>
            <FormattedMessage
                id="clanmanagement.tooltips.attack_10_column_body"
                defaultMessage="Нажмите, чтобы отсортировать игроков по количеству боёв в Вылазках в X дивизионе."
            />
        </TooltipBody>
    </div>
)
Attack10ColumnTooltipContent.tip = 'attack-10-column-tooltip-tip'


export const FortBattlesColumnTooltipContent = () => (
    <div>
        <TooltipBody>
            <TooltipSubtitle>
                <FormattedMessage
                    id="clanmanagement.tooltips.fort_battles_column_header"
                    defaultMessage="Бои в Наступлениях"
                />
            </TooltipSubtitle>
            <FormattedMessage
                id="clanmanagement.tooltips.fort_battles_column_body"
                defaultMessage="Нажмите, чтобы отсортировать игроков по количеству боёв в Наступлениях."
            />
        </TooltipBody>
    </div>
)
FortBattlesColumnTooltipContent.tip = 'fort-battles-column-tooltip-tip'


export const ResourceColumnTooltipContent = () => (
    <div>
        <TooltipBody>
            <TooltipSubtitle>
                <FormattedMessage
                    id="clanmanagement.tooltips.resource_column_header"
                    defaultMessage="Промресурс"
                />
            </TooltipSubtitle>
            <FormattedMessage
                id="clanmanagement.tooltips.resource_column_body"
                defaultMessage="Нажмите, чтобы отсортировать игроков по количеству промресурса, заработанного за выбранный период."
            />
        </TooltipBody>
    </div>
)
ResourceColumnTooltipContent.tip = 'resource-column-tooltip-tip'


export const PlayerStatusColumnTooltipContent = () => (
    <div>
        <TooltipBody>
            <TooltipSubtitle>
                <FormattedMessage
                    id="clanmanagement.tooltips.player_status_column_header"
                    defaultMessage="Последнее время игры"
                />
            </TooltipSubtitle>
            <FormattedMessage
                id="clanmanagement.tooltips.player_status_column_body"
                defaultMessage="Нажмите, чтобы отсортировать игроков по времени, которое прошло с момента последнего выхода из игры."
            />
        </TooltipBody>
    </div>
)
PlayerStatusColumnTooltipContent.tip = 'player-status-column-tooltip-tip'


export const NotPlayedInClanModesTooltip = () => (
    <Tooltip id={NotPlayedInClanModesTooltip.id}>
        <TooltipBody>
            <FormattedMessage
                id="clanmanagement.tooltip.not_played_in_clan_modes.body"
                defaultMessage="Игрок не участвовал в боях в составе клана"
            />
        </TooltipBody>
    </Tooltip>
)
NotPlayedInClanModesTooltip.id = 'clanmanagement.tooltip.not_played_in_clan_modes'


export const NotLoggedInEverTooltip = () => (
    <Tooltip id={NotLoggedInEverTooltip.id}>
        <TooltipBody>
            <FormattedMessage
                id="clanmanagement.tooltips.not_logged_ever_body"
                defaultMessage="Ещё не заходил в игру"
            />
        </TooltipBody>
    </Tooltip>
)
NotLoggedInEverTooltip.id = 'clanmanagement.tooltip.not_logged_ever_body'


export const NameTooltipContent = ({ name }) => (
    <TooltipBody>
        {name}
    </TooltipBody>
)
NameTooltipContent.propTypes = {
    name: PropTypes.string.isRequired,
}


export const RoleTooltipContent = ({ role }) => (
    <TooltipBody>
        {USER_ROLES[role]}
    </TooltipBody>
)
RoleTooltipContent.propTypes = {
    role: PropTypes.string.isRequired,
}


export const BattlesInClanTooltipContent = ({ battles, winrate }) => (
    <TooltipBody>
        <TooltipSubtitle>
            <FormattedMessage
                id="clanmanagement.tooltips.battles_in_clan_header"
                defaultMessage="Бои в составе клана"
            />
        </TooltipSubtitle>
        <p>
            <FormattedMessage
                id="clanmanagement.tooltips.battles_in_clan_body1"
                defaultMessage="Количество боёв: {battles}"
                values={{ battles: <span className="tooltip-important-lbl">{battles}</span> }}
            />
        </p>
        <p>
            <FormattedMessage
                id="clanmanagement.tooltips.battles_in_clan_body2"
                defaultMessage="Победы: {winrate}"
                values={{ winrate: <span className="tooltip-important-lbl">{winrate}</span> }}
            />
        </p>
    </TooltipBody>
)

export const LeavingClanTooltip = () => (
    <Tooltip id={LeavingClanTooltip.id}>
        <TooltipBody>
            <FormattedMessage
                id="clanmanagement.tooltips.leaving_the_clan_tooltip'"
                defaultMessage="Покинуть клан"
            />
        </TooltipBody>
    </Tooltip>
)
LeavingClanTooltip.id = 'leaving-the-clan-tooltip'

BattlesInClanTooltipContent.propTypes = {
    battles: PropTypes.string.isRequired,
    winrate: PropTypes.string.isRequired,
}



// WEBPACK FOOTER //
// ./containers/ClanManagement/components/ClanManagement/tooltips.js